import { render, staticRenderFns } from "./CategoryAddButton.vue?vue&type=template&id=569a107d&scoped=true&"
import script from "./CategoryAddButton.vue?vue&type=script&lang=js&"
export * from "./CategoryAddButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAddButton.vue?vue&type=style&index=0&id=569a107d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569a107d",
  null
  
)

component.options.__file = "CategoryAddButton.vue"
export default component.exports